import React, { forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import styled from 'styled-components'

const Input = styled.div`
  border-radius: 6px;
  font-size: 14px;
  height: 34px;
  border: 1px solid ${({ theme }) => theme.mocaGrey};
  background: ${({ theme }) => theme.white};
  padding: 6px 12px;
  min-width: 140px;
`

export const dateTimePickerFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { field, fn, format = 'MM/dd/yyyy HH:mm', placeholder = '' } = formatExtraData
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <Input onClick={onClick} ref={ref}>
      {value || placeholder}
    </Input>
  ))

  return (
    <DatePicker
      selected={moment(row[field]).toDate()}
      onChange={date => fn(date, row, field, rowIndex)}
      timeInputLabel="Time:"
      dateFormat={format}
      customInput={<CustomInput />}
      showTimeInput
    />
  )
}
